import Vue from 'vue'
import svgicon from 'vue-svgicon'
import '@/components/icons'

Vue.use(svgicon, { tagName: 'icon' })
